export default "__VITE_ASSET__k0$nOjxf__"